import { render, staticRenderFns } from "./Pleitos.vue?vue&type=template&id=2172ecb4"
import script from "./Pleitos.vue?vue&type=script&lang=js"
export * from "./Pleitos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports